import { ALL_GRANULARITY } from '../../constants/analytics';
import { DATE_RANGE } from '../../constants/cenariusDimensions';
import { DrilldownMapperBase } from './DrilldownMapperBase';

type Column = { key: string };

export class DrilldownMapperUp extends DrilldownMapperBase {
  private _dimensions?: string[] = undefined;

  private _columns?: Column[] = undefined;

  private calculateDimensions() {
    if (!this.hasGranularityDimension && !this.granularityIsAll) {
      return this.dimensions.concat(this.granularityToDimensionMap[this.granularity]).filter((d) => d !== DATE_RANGE);
    } else if (!this.granularityIsAll) {
      return this.dimensions.filter((d) => d !== DATE_RANGE);
    }
    return this.dimensions;
  }

  private calculateColumns() {
    const dimensions = this.getDimensions();
    const dimensionColumns = dimensions.map((dimension) => ({ key: dimension }));

    const columns = this.selectedColumns.filter(
      (selectedColumn) => !dimensions.includes(selectedColumn.key) && selectedColumn.key !== DATE_RANGE
    );

    return [...dimensionColumns, ...columns];
  }

  needsUpdate() {
    return !this.hasGranularityDimension && !this.granularityIsAll;
  }

  getSelectedColumns() {
    if (this._columns === undefined) {
      this._columns = this.calculateColumns();
    }
    return this._columns;
  }

  getDimensions() {
    if (this._dimensions === undefined) {
      this._dimensions = this.calculateDimensions();
    }
    return this._dimensions;
  }

  getGranularity(): string | undefined {
    return ALL_GRANULARITY;
  }

  getActiveHeader(): string {
    const columns = this.getSelectedColumns();
    const backupActiveHeader = columns[0].key;

    if (!this.activeHeader) {
      return backupActiveHeader;
    }

    return columns.some((c) => c.key === this.activeHeader) ? this.activeHeader : backupActiveHeader;
  }
}
